export var CurveType;
(function (CurveType) {
    CurveType["LINEAR"] = "linear";
    CurveType["ARC"] = "arc";
    CurveType["QUADRATIC_BEZIER"] = "quadratic-bezier";
    CurveType["CLOTHOID"] = "clothoid";
    CurveType["PARABOLIC_CURVE"] = "parabolic-curve";
})(CurveType || (CurveType = {}));
//# sourceMappingURL=interface.js.map